/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button, Card } from 'react-bootstrap';
import JSON5 from 'json5';

import {
  getIntegrationConfig,
  saveIntegrationConfig,
} from 'service/InstallerApp';
import { addError, addSuccess } from 'rdx/alert';
import './msconfig.scss';

function MSConfigForm({ entity, version }) {
  const dispatch = useDispatch();

  const [config, setConfig] = useState('');
  const [currentConfig, setCurrentConfig] = useState('');
  useEffect(() => setConfig(currentConfig), [currentConfig]);
  useEffect(() => {
    if (entity && version) {
      getIntegrationConfig(entity, version)
        .then(({ data: { config: conf } }) => setCurrentConfig(conf))
        .catch((err) => {
          dispatch(
            addError(
              `Unable to parse the locally stored configuration for microservice(entity: ${entity}, version: ${version})`,
              { selfDismiss: false, dismissible: true },
            ),
          );
          setConfig('');
          dispatch(addError(err.message));
        });
    }
  }, [entity, version]);

  const onSave = () => {
    saveIntegrationConfig(entity, version, config)
      .then((res) => {
        if (res.status === 'OK') {
          dispatch(
            addSuccess('Updated Micro-service configuration successfully!'),
          );
          setCurrentConfig(res.data.config);
        } else {
          throw new Error(res.message);
        }
      })
      .catch((e) => dispatch(addError(e.message)));
  };

  const autofixButton = useMemo(() => {
    const fixJSON = () =>
      setConfig((c) => JSON.stringify(JSON5.parse(c), undefined, 2));
    try {
      JSON.parse(config);
      return (
        <Button variant="success" onClick={fixJSON} size="sm">
          Valid JSON (click to autoformat)
        </Button>
      );
    } catch (e) {
      try {
        JSON5.parse(config);
        return (
          <Button variant="warning" onClick={fixJSON} size="sm">
            Invalid JSON (click to fix)
          </Button>
        );
      } catch (err) {
        return (
          <Button disabled variant="danger" size="sm">
            Invalid JSON (cannot autofix)
          </Button>
        );
      }
    }
  }, [config]);

  return (
    <Card className=" my-3">
      <Card.Header>Micro-service configuration</Card.Header>
      <Card.Body className="microservice-configuration">
        <div className="existing-header">Current config.json</div>
        <textarea className="existing" value={currentConfig} disabled />
        <div className="new-header">New configuration</div>
        <textarea
          className="new"
          value={config}
          onChange={(e) => setConfig(e.target.value)}
        />
        <div className="existing-buttons">
          <Button disabled={config === currentConfig} onClick={onSave}>
            {config === currentConfig
              ? 'Configuration saved'
              : 'Save new configuration'}
          </Button>
        </div>
        <div className="new-buttons">{autofixButton}</div>
      </Card.Body>
    </Card>
  );
}

MSConfigForm.propTypes = {
  entity: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
};

export default MSConfigForm;
